import { GroupOperator } from './types'

interface SegmentGroupSeparatorProps {
  operator: GroupOperator
  isExceptGroup: boolean
}

const SegmentGroupSeparator = ({
  operator,
  isExceptGroup,
}: SegmentGroupSeparatorProps) => {
  // NOTE: Architecture alignment - Display operator as separator between groups
  // This may need to be updated if operator representation changes
  const separatorClassName = isExceptGroup
    ? 'thanx-ai-segment-visualization__group-separator thanx-ai-segment-visualization__group-separator--except'
    : 'thanx-ai-segment-visualization__group-separator'

  return <div className={separatorClassName}>{operator}</div>
}

export default SegmentGroupSeparator
